<template>
  <span :onClick="openModal">
    <slot></slot>
  </span>

  <BaseModal
    modal-class="userprefs-modal"
    triggerIdToFocus="userprefs"
    @update:state="updateIsOpenHandler"
  >
    <template #modal-content>
      <div class="base-model__content">
        <div class="base-model__header base-model__header--border">
          <p class="base-model__header-title heading-h5">Share on social</p>
          <button
            role="button"
            aria-label="Dismiss modal"
            class="button--text button--icon base-model__header-close"
            :onClick="closeModal"
          >
            <i class="icon icon-close icon--xs" aria-hidden="true"></i>
          </button>
        </div>
        <div class="base-model__body base-model__body--padded">
          <div class="social-sharing-config__block">
            <div class="social-sharing-config__block-text">
              <p class="text-KQ-Grey2">Share</p>
            </div>
            <div class="social-sharing-config__block-icons">
              <a
                target="_blank"
                aria-label="Go to Kenya Airway's facebook page"
                :href="'https://facebook.com/sharer.php?u=' + props.articleLink"
              >
                <i
                  class="
                    icon icon-facebook
                    icon-color--gold
                    icon--hoverable icon--xs
                  "
                  aria-hidden="true"
                ></i>
              </a>

              <a
                target="_blank"
                aria-label="Go to Kenya Airway's twitter page"
                :href="'https://www.twitter.com/share?url=' + props.articleLink"
              >
                <i
                  class="
                    icon icon-twitter
                    icon-color--gold
                    icon--hoverable icon--xs
                  "
                  aria-hidden="true"
                ></i>
              </a>

              <a
                target="_blank"
                aria-label="email"
                :href="'mailto:?body=' + props.articleLink"
              >
                <i
                  class="
                    icon icon-mail-thin-filled
                    icon-color--gold
                    icon--hoverable icon--xs
                  "
                  aria-hidden="true"
                ></i>
              </a>

              <copy-link :articleLink="props.articleLink" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import { provide, ref } from 'vue';
import BaseModal from '../BaseModal/BaseModal.vue';
import CopyLink from '../CopyLink/CopyLink.vue';

const isOpen = ref(false);

provide('injectedIsOpen', isOpen);

const props = defineProps({
  articleLink: {
    type: String,
    default: '',
  },
  facebookLink: {
    type: String,
    default: '',
  },
  youtubeLink: {
    type: String,
    default: '',
  },
  twitterLink: {
    type: String,
    default: '',
  },
  mailLink: {
    type: String,
    default: '',
  },
});

const openModal = (e) => {
  isOpen.value = true;
};

const closeModal = (e) => {
  isOpen.value = false;
};

const updateIsOpenHandler = (value) => {
  isOpen.value = false;
};
</script>
